"use client";
import React from "react";
import { usePathname } from "next/navigation";
import Sidebar from "./sidebar";
import Header from "./header";

const HIDE_CHROME_ON = new Set<string>([
  "/", // página de inicio (sin sidebar ni navbar)
]);

export default function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // Sin sidebar ni navbar en las rutas definidas
  if (HIDE_CHROME_ON.has(pathname)) {
    return <div className="min-h-screen bg-gray-50">{children}</div>;
  }

  // Con sidebar + header para el resto
  return (
    <div className="min-h-screen flex">
      <Sidebar /> {/* 👈 sin wrapper extra */}
      <main className="flex flex-col flex-1">
        <Header />
        <div className="">{children}</div>
      </main>
    </div>
  );
}
